import { observeScrolledPast } from '@/js/helpers/observeScrolledPast'

export class LinkToTop {
	public static selector: string = '.js-link-to-top'

	private element: HTMLElement
	private link: HTMLAnchorElement

	public constructor(element: HTMLElement) {
		const link = element.querySelector<HTMLAnchorElement>(`${LinkToTop.selector}__link`)

		if (!link) {
			throw new Error('Missing link element in LinkToTop component.')
		}

		this.element = element
		this.link = link

		const targetElement = this.getTargetElement()

		if (!targetElement) {
			return
		}

		observeScrolledPast(
			targetElement,
			(isVisible) => this.element.classList.toggle('active', isVisible),
			'50% 0px 0px 0px'
		)
	}

	private getTargetElement(): HTMLElement | null {
		const targetId = this.link.getAttribute('href')?.substring(1) || ''
		return document.getElementById(targetId)
	}
}
